import { render, staticRenderFns } from "./MatchReadCPopup.vue?vue&type=template&id=df6886fe&scoped=true"
import script from "./MatchReadCPopup.vue?vue&type=script&lang=js"
export * from "./MatchReadCPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6886fe",
  null
  
)

export default component.exports